import React, { Component } from 'react';

export class Div extends Component {
    render() {
        const {
            isPopOverOpen, // eslint-disable-line no-unused-vars
            tooltipHideDelay, // eslint-disable-line no-unused-vars
            theme, // eslint-disable-line no-unused-vars
            loading, // eslint-disable-line no-unused-vars
            handleClickOutside, // eslint-disable-line no-unused-vars
            handleInsideClick, // eslint-disable-line no-unused-vars
            useCapture, // eslint-disable-line no-unused-vars
            intersectionId, // eslint-disable-line no-unused-vars
            small, // eslint-disable-line no-unused-vars
            innerRef,
            ...others
        } = this.props;
        return <div ref={innerRef} {...others} />;
    }
}

export default Div;
